import { useEffect, useRef, useState } from 'react';
import { Button, Carousel, Flex, Image, Typography, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faClock, faDirections, faFlag, faGlobe, faLocationDot, faPhone, faHashtag, faWrench, faShare, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { withAlert } from 'react-alert';
import { LoadingOutlined } from '@ant-design/icons';
import GeneralHelper from '../../helpers/general';
import fallbackImg from '../../images/placeholder.png';
import useIsMobile from '../../helpers/customHooks/useIsMobile';
import { useSharedIndoorPositioning } from '../../contexts/IndoorPositioning';
import { CURRENT_LOCATION_VALUE } from '../../constants/CurrentLocationOption';
import ContentDrawer from '../../components/ContentDrawer';

const { Title, Paragraph, Link, Text } = Typography;

const LocationDetailPage = (props) => {
	const { pageProps, getLocaationIdByRemoteId, getLocationDetailsById, getLocationBuildingFloorsById, getBuildingFloorGeojson, getBuildingFloorNavNodes, resetPage } = props;
	const { location_id, location_details, location_building_floors, loading_details, loading_assets, location_assets, meta } = pageProps;
	const [buildingId, setBuildingId] = useState(null);
	const [drawerOpen, setDrawerOpen] = useState(false);

	const query = GeneralHelper.getParamsFromUrl();
	const { id, remote_id, building_floor_id } = query || {};

	const history = useHistory();
	const location = useLocation();

	const drawerRef = useRef({});
	const titleRef = useRef(null);
	const drawerContainerRef = useRef(null);

	const { position: userLocation } = useSharedIndoorPositioning();

	const name = location_details?.full_name || location_details?.name;
	const description = location_details?.description || location_details?.public_description;

	const isMobile = useIsMobile();

	const canReportDefect = query && query.id && location_details && location_details.remote_id;
	const generalDefectUrl = canReportDefect
		// ? `https://cas.ust.hk/cas/login?service=https%3A%2F%2Fmaximo.ust.hk%2Fmaximo%2Fui%2Fmaximo.jsp%3Fevent%3Dloadapp%26value%3Dust_drs4s%26additionalevent%3Dinsert%26additionaleventvalue%3Dlocation%3D${location_details.remote_id}`
		? `https://cas.ust.hk/cas/login?service=https%3A%2F%2Fmaximo.ust.hk%2Fmaximo%2Fui%2Fmaximo.jsp%3Fevent%3Dloadapp%26value%3Dust_drs4s%26additionalevent%3Dinsert%26additionaleventvalue%3Dust_spaceid%3D${location_details.remote_id}`
		: null;

	const labDefectUrl = canReportDefect
		// ? `https://cas.ust.hk/cas/login?service=https%3A%2F%2Fmaximo.ust.hk%2Fmaximo%2Fui%2Fmaximo.jsp%3Fevent%3Dloadapp%26value%3Dust_ldrs4s%26additionalevent%3Dinsert%26additionaleventvalue%3Dlocation%3D${location_details.remote_id}`
		? `https://cas.ust.hk/cas/login?service=https%3A%2F%2Fmaximo.ust.hk%2Fmaximo%2Fui%2Fmaximo.jsp%3Fevent%3Dloadapp%26value%3Dust_ldrs4s%26additionalevent%3Dinsert%26additionaleventvalue%3Dust_spaceid%3D${location_details.remote_id}`
		: null;

	// ANCHOR handlers
	// FIXME
	const handleDirecitonsOnClick = (_, id, start = false) => {
		const queryObject = { ...query };
		if (location_details.name)
			queryObject[start ? 'start' : 'end'] = id;

		// Fill in the other end with where the user is standing, but only when positioning already
		// knows - offering it is worth a tap saved, whereas starting a detection they did not ask
		// for could leave them watching a spinner for 20s before the form is even usable.
		const counterpart = start ? 'end' : 'start';
		if (!queryObject[counterpart] && userLocation && GeneralHelper.isObjectId(userLocation.building_floor_id)) {
			queryObject[counterpart] = CURRENT_LOCATION_VALUE;
		}

		const queryString = GeneralHelper.objectToQueryString(queryObject);
		history.push(`directions?${queryString}`);
	};

	const handleGoBack = () => {
		resetPage();
		history.push('/');
	};
	// ANCHOR end handlers

	// ANCHOR useEffects
	useEffect(() => {
		if (remote_id) getLocaationIdByRemoteId({ remote_id });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [remote_id]);

	useEffect(() => {
		if (location_id)
			history.push(`/location/id?${GeneralHelper.objectToQueryString({ id: location_id })}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location_id]);

	useEffect(() => {
		if (id) getLocationDetailsById({ id });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	useEffect(() => {
		if (location_details) {
			setBuildingId(state => state !== location_details.building_id ? location_details.building_id : state);
			setDrawerOpen(!location_details?.is_building);
		}

		if (titleRef) {
			drawerRef.current.title = titleRef.current;
		}
	}, [location_details]);

	useEffect(() => {
		if (buildingId) getLocationBuildingFloorsById({ building_id: buildingId, limit: 50 });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [buildingId]);

	useEffect(() => {
		if (location_building_floors) {
			if (!building_floor_id || !GeneralHelper.isObjectId(building_floor_id)) {

				let default_building_floor = location_building_floors.find(
					(floor) => floor.is_default && floor.show_in_path_advisor
				);

				if (!default_building_floor) {
					default_building_floor = location_building_floors.find(
						(floor) => floor.name.toLowerCase() === 'g' && floor.show_in_path_advisor
					);
				}

				// If still no floor is found, select the first visible floor
				if (!default_building_floor) {
					default_building_floor = location_building_floors.find(
						(floor) => floor.show_in_path_advisor
					);
				}

				if (default_building_floor) {
					const queryString = GeneralHelper.objectToQueryString({
						...query,
						building_floor_id: default_building_floor._id
					});
					history.push(`${location.pathname}?${queryString}`);
				}
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location_building_floors, building_floor_id]);

	useEffect(() => {
		if (GeneralHelper.isObjectId(building_floor_id)) {
			getBuildingFloorGeojson({ building_floor_id: building_floor_id });
			getBuildingFloorNavNodes({ building_floor_id: building_floor_id });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [building_floor_id]);
	// ANCHOR end useEffects

	// ANCHOR Components
	const renderDrawerTitle = () => {
		return (
			<Title
				level={1}
				style={{ fontSize: '1.4rem', marginBlockEnd: 0 }}
			>
				{name}
			</Title>
		);
	};

	const regularImages = location_assets && location_assets.filter(asset => asset.location_information_type === null || asset.location_information_type !== 'seating_plan') || [];
	const seatingPlanImages = location_assets && location_assets.filter(asset => asset.location_information_type === 'seating_plan') || [];

	return (
		<>
			<div
				className="content-drawer-container"
				ref={drawerContainerRef}
			>
				<ContentDrawer
					nudge
					nudgeDistance={40}
					loading={loading_details}
					// A building's page has little to read beyond its name, which the handle already
					// shows — its floor plan is what people open it for.
					openOnLoad={!location_details?.is_building}
					goBack={handleGoBack}
					title={renderDrawerTitle}
					handleLabel={loading_details ? <><LoadingOutlined /> Location</> : location_details?.full_name || `${location_details?.name}, ${location_details?.building_short_name}`}
					drawerProps={{
						getContainer: () => drawerContainerRef.current
					}}
				>
					<div className="hkust content">
						<span className="handle"></span>
						{
							location_details ?
								<>
									<div className="content-body scrollable">
										<div className="details">
											{
												!isMobile && (!loading_assets && regularImages && regularImages.length) ? (
													<div className="cover">
														<Image
															src={regularImages[0] ? regularImages[0]?.file_content : 'error'}
															alt={name}
															width="100%"
															style={{ aspectRatio: '1.60/1', objectFit: 'cover', maxHeight: 254 }}
															preview={false}
														/>
													</div>
												) : null
											}

											<div className="content-inner">
												<div className="head">
													{!isMobile && (
														<Title
															level={1}
															style={{ fontSize: '1.4rem' }}
														>
															{name}
														</Title>)
													}

													<Paragraph>
														{description}
													</Paragraph>

													<div className="buttons">
														<Flex gap={12}>
															{location_details && !location_details.is_building && (
																<Button
																	onClick={(e) => (handleDirecitonsOnClick(e, location_details._id))}
																	type="primary"
																	icon={<FontAwesomeIcon icon={faDirections} />}
																	style={{ paddingInline: 8, flex: '0 1' }}
																>
																	Directions
																</Button>
															)}
															{
																// (isMobile && !location_details?.is_building) &&
																// <Button
																// 	onClick={(e) => (handleDirecitonsOnClick(e, location_details._id, true))}
																// 	type="primary"
																// 	icon={<FontAwesomeIcon icon={faPlayCircle} />}
																// 	style={{ paddingInline: 8, flex: '0 1' }}
																// 	ghost
																// >
																// 	Start
																// </Button>
															}
															{location_details && !location_details.is_building && (
																<Button
																	type="default"
																	onClick={() => {
																		const shareUrl = `https://navigate.ust.hk/path/app/location/id?remote_id=${location_details.remote_id}`;
																		navigator.clipboard.writeText(shareUrl).then(() => {
																			message.success('Link copied to clipboard!');
																		}).catch((err) => {
																			message.error('Failed to copy link');
																		});
																	}}
																	style={{
																		paddingInline: 8,
																		flex: '0 1',
																		color: '#0088FF',
																		backgroundColor: 'white',
																		borderColor: '#0088FF'
																	}}
																	icon={<FontAwesomeIcon icon={faShare} />}
																>
																	Share
																</Button>
															)}
														</Flex>
													</div>
												</div>

												<div className="body">
													{
														(location_details && !location_details?.is_building) &&
														<div>
															<Title
																level={5}
																style={{ fontSize: '1rem' }}
															>
																Details
															</Title>

															<Flex
																vertical
																gap={8}
															>
																{
																	location_details?.address &&
																	<Flex
																		gap={12}
																		align="flex-start"
																	>
																		<FontAwesomeIcon
																			icon={faLocationDot}
																			width={12}
																			color="#0059B1"
																			style={{ transform: 'translateY(4px)' }}
																		/>
																		<Paragraph style={{ marginBlockEnd: 0 }}>{location_details.address}</Paragraph>
																	</Flex>
																}
																{
																	location_details?.capacity ?
																		<Flex
																			gap={12}
																			align="flex-start"
																		>
																			<FontAwesomeIcon
																				icon={faUsers}
																				width={12}
																				color="#0059B1"
																				style={{ transform: 'translateY(4px)' }}
																			/>
																			<Paragraph style={{ marginBlockEnd: 0 }}>
																				<Text style={{ marginInlineEnd: 8 }}>Capacity</Text>
																				{location_details.capacity}
																			</Paragraph>
																		</Flex> : null
																}
																{/* {
																	location_details?.remote_id &&
																	<Flex
																		gap={12}
																		align="flex-start"
																	>
																		<FontAwesomeIcon
																			icon={faHashtag}
																			width={12}
																			color="#0059B1"
																			style={{ transform: 'translateY(4px)' }}
																		/>
																		<Paragraph style={{ marginBlockEnd: 0 }}>{location_details.remote_id}</Paragraph>
																	</Flex>
																} */}
																{
																	(location_details?.business_hours && location_details.business_hours.length) ?
																		<Flex
																			gap={12}
																			align="flex-start"
																		>
																			<FontAwesomeIcon
																				icon={faClock}
																				width={12}
																				style={{ transform: 'translateY(4px)' }}
																				color="#0059B1"
																			/>
																			<Flex
																				vertical
																				gap={0}
																			>
																				{location_details.business_hours.map((business_hour) => (
																					<Paragraph
																						style={{ marginBlockEnd: 0 }}
																						key={business_hour.day}
																					>
																						<Text style={{ marginInlineEnd: 8 }}>{business_hour.day}</Text>
																						{business_hour.opening_time} - {business_hour.closing_time}
																					</Paragraph>
																				))}
																			</Flex>
																		</Flex> : null
																}

																{
																	location_details?.phone_number &&
																	<Flex
																		gap={12}
																		align="flex-start"
																	>
																		<FontAwesomeIcon
																			icon={faPhone}
																			width={12}
																			color="#0059B1"
																			style={{ transform: 'translateY(4px)' }}
																		/>
																		<Paragraph style={{ marginBlockEnd: 0 }}>{location_details.phone_number}</Paragraph>
																	</Flex>
																}

																{location_details?.url && location_details?.url.length > 0 &&
																	<Flex
																		gap={12}
																		align="flex-start"
																	>
																		<FontAwesomeIcon
																			icon={faGlobe}
																			width={12}
																			color="#0059B1"
																			style={{ transform: 'translateY(4px)' }}
																		/>
																		<Flex
																			vertical
																			gap={0}
																		>
																			{
																				location_details.url.map((website) => (
																					<Link
																						href={website.url}
																						target="_blank"
																						key={website.label}
																					>
																						{website.label}
																					</Link>
																				))
																			}
																		</Flex>
																	</Flex>
																}

																{location_details?.equipments && location_details?.equipments.length > 0 &&
																	<Flex
																		gap={12}
																		align="flex-start"
																	>
																		<FontAwesomeIcon
																			icon={faWrench}
																			width={12}
																			color="#0059B1"
																			style={{ transform: 'translateY(4px)' }}
																		/>
																		<Flex
																			vertical
																			gap={0}
																		>
																			<Paragraph style={{ marginBlockEnd: 0 }}>
																				{location_details?.equipments.join(', ')}
																			</Paragraph>
																		</Flex>
																	</Flex>
																}
															</Flex>

														</div>
													}
												</div>
												{!loading_assets && regularImages.length ? (
													<div className="carousel">
														<Title
															level={5}
															style={{ fontSize: '1rem' }}
														>
															Images
														</Title>
														<Carousel
															draggable
															slidesPerRow={3}
															infinite={false}
															style={{ margin: -6 }}
														>
															{regularImages.map((image) => (
																<div key={image.uuid}>
																	<Image
																		src={image?.file_content}
																		alt={name}
																		width="100%"
																		style={{ aspectRatio: '2/3', objectFit: 'cover', borderRadius: 12, padding: 6 }}
																		fallback={fallbackImg}
																	/>
																</div>
															))}
														</Carousel>
													</div>
												) : null}

												{!loading_assets && seatingPlanImages.length ? (
													<div className="carousel">
														<Title
															level={5}
															style={{ fontSize: '1rem' }}
														>
															Seating Plan
														</Title>
														<Carousel
															draggable
															slidesPerRow={3}
															infinite={false}
															style={{ margin: -6 }}
														>
															{seatingPlanImages.map((image) => (
																<div key={image.uuid}>
																	<Image
																		src={image?.file_content}
																		alt={`${name} Seating Plan`}
																		width="100%"
																		style={{ aspectRatio: '2/3', objectFit: 'cover', borderRadius: 12, padding: 6 }}
																		fallback={fallbackImg}
																	/>
																</div>
															))}
														</Carousel>
													</div>
												) : null}
												{
													(canReportDefect) &&
													<div className="report">
														<Link
															href={generalDefectUrl}
															target="_blank"
														>
															<Flex
																gap={10}
																align="center"
															>
																<span>Report General Defect</span>
																<FontAwesomeIcon
																	icon={faFlag}
																	width={10}
																/>
															</Flex>
														</Link>
														<Link
															href={labDefectUrl}
															target="_blank"
														>
															<Flex
																gap={10}
																align="center"
															>
																<span>Report Lab Defect</span>
																<FontAwesomeIcon
																	icon={faFlag}
																	width={10}
																/>
															</Flex>
														</Link>
													</div>
												}

											</div>
										</div>
									</div>
								</>
								:
								<div style={{ padding: '24px 24px 0 24px' }}>
									<Title
										level={5}
										style={{ fontSize: 16, marginBlockEnd: 24 }}
									>
										{meta?.message}
									</Title>
								</div>
						}
					</div >
				</ContentDrawer>
			</div>
		</>
	);
};

export default compose(withAlert())(LocationDetailPage);